module.exports = __webpack_public_path__ + "img/c06_unitstartechramshipchampion_Normal_ua.a5a5f6bb.webp";